import { render, staticRenderFns } from "./ChatEntrance.vue?vue&type=template&id=5f81a86d&scoped=true&"
import script from "./ChatEntrance.vue?vue&type=script&lang=js&"
export * from "./ChatEntrance.vue?vue&type=script&lang=js&"
import style0 from "./ChatEntrance.vue?vue&type=style&index=0&id=5f81a86d&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f81a86d",
  null
  
)

export default component.exports